import { inject, Pipe, PipeTransform } from '@angular/core'
import { RedirectorService } from 'src/app/service/redirector.service'

@Pipe({ name: 'promoLink', standalone: true })
export class PromoLinkPipe implements PipeTransform {
  protected context = inject(RedirectorService).getContext()

  transform (url: string) {
    const urlObject = new URL(url)
    urlObject.searchParams.set('utm_source', 'redirector')
    urlObject.searchParams.set('utm_medium', this.context.config.type)
    urlObject.searchParams.set('utm_campaign', this.context.config.template)
    urlObject.searchParams.set('utm_term', this.context.config.name)

    return urlObject.toString()
  }
}
